export default __webpack_public_path__ + "static/media/LogoWhiteScreen15Years.ce7a224f.svg";